import { render, staticRenderFns } from "./CreaCuenta.vue?vue&type=template&id=87c65a8c"
import script from "./CreaCuenta.vue?vue&type=script&lang=js"
export * from "./CreaCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports